// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","913":"BusinessProGuestLazyComponent"}[chunkId] + "." + {"46":"e20c5a7ef4c5e717c679","913":"f4b862323eb1ed99394f"}[chunkId] + ".js";
};